var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"falling"},_vm._l((100),function(item){return _c('div',{staticClass:"box"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }